<template>
  <span>
    <template v-if="!editing">
      <span v-if="!editing">{{ value }}</span>
      <span key="i1" @click="editing = true" v-if="!editing">
        <i class="fas fa-edit clickable"></i>
      </span>
    </template>
    <template v-else>
      <span class="embedded-input-container">
        <input ref="inp" class="embedded-input" :class="{uppercase}" :value="value" @keyup.enter="emit" />
        <span class="microbtn ok clickable" @click="emit">
          <i class="fas fa-check-circle"></i>
        </span>
        <span class="microbtn cancel clickable" @click="editing = false">
          <i class="fas fa-times-circle"></i>
        </span>
      </span>
      <WaveSpinner inline v-if="busy"/>
      <span class="error" v-if="error" v-html="error"/>
    </template>
  </span>
</template>

<script>
export default {
  props: {
    value: String,
    uppercase: Boolean
  },
  data() {
    return {editing: false, busy: false, error: ''}
  },
  methods: {
    async emit() {
      // We emit an input to allow easy v-model, plus a custom callback as a second argument.
      // The @input handler can pass a promise to the callback. this will wait for the promise to
      // resolve to remove the input, showing a busy indicator, and showing an error if the promise
      // errors.
      let promise = Promise.resolve();
      this.busy = true;
      this.error = '';
      this.$emit('input', this.$refs.inp.value, p => promise = p);
      try {
        await promise;
        this.editing = false;
      } catch(e) {
        console.error(e);
        this.error = e+'';
      }
      this.busy = false;
    }
  }
}
</script>

<style scoped lang="scss">
@import "~scss/colors";

.embedded-input-container {
  position: relative;
  padding: 5px 0 10px 5px;

  .embedded-input {
    border: 1px solid $gray-0;
    border-radius: 0;
    margin: -3px -6px;
    padding: 2px 4px;
    line-height: 13px;
    width: 10em;  // Note: this may have to be parameterized
    font-size: 13px;
    &.uppercase {
      text-transform: uppercase;
      letter-spacing: 2px;
      font-weight: bold;
    }
  }

  .microbtn {
    position: absolute;
    top: 9px;
    font-size: 13px;

    &.ok {
      color: $alert-green;
      right: 16px;
    }

    &.cancel {
      color: $alert-red;
      right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/InlineEditToggle.vue